import { render } from "./SupersetCardItem.vue?vue&type=template&id=a8f128d4"
import script from "./SupersetCardItem.vue?vue&type=script&lang=js"
export * from "./SupersetCardItem.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__